import colors from "../../utils/colors";

export default {
  textStyle: {
    fontSize: "0.9em",
    fontWeight: 600,
    color: colors.textColor,
  },
} as any;
